/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bee-breadcrumbs.vue?vue&type=template&id=9e27437e&scoped=true"
import script from "./bee-breadcrumbs.vue?vue&type=script&lang=js"
export * from "./bee-breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./bee-breadcrumbs.vue?vue&type=style&index=0&id=9e27437e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e27437e",
  null
  
)

export default component.exports